import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const RouteScrollManager = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previousLocationRef = useRef(null);

  useEffect(() => {
    const previousLocation = previousLocationRef.current;

    if (!previousLocation) {
      previousLocationRef.current = location;
      return;
    }

    const pathnameChanged = previousLocation.pathname !== location.pathname;

    if (pathnameChanged && (navigationType === 'PUSH' || navigationType === 'REPLACE')) {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } catch (error) {
        window.scrollTo(0, 0);
      }
    }

    previousLocationRef.current = location;
  }, [location, navigationType]);

  return null;
};

export default RouteScrollManager;
